import {
  ioRepositoriesFolderRuleDelete,
  ioRepositoriesFolderRuleGet,
  ioRepositoriesFolderRulePost,
  ioRepositoriesFolderRulesList,
  ioRepositoriesFolderRuleUpdate
} from '@/febos/servicios/api/rules.api';

export const getRulesFolder = async ({ commit }, { repositoryId, folderId, filters }) => {
  const response = await ioRepositoriesFolderRulesList({ repositoryId, folderId, filters });
  commit('SET_RULES', {
    id: folderId,
    rules: response.data.rules
  });
};

// eslint-disable-next-line no-unused-vars
export const loadRulesFolder = async ({ commit }, { repositoryId, folderId, ruleId }) => {
  const response = await ioRepositoriesFolderRuleGet({ repositoryId, folderId, ruleId });
  return response.data.rule;
};
// eslint-disable-next-line no-unused-vars
export const deleteRuleFolder = async ({ commit }, { repositoryId, folderId, ruleId }) => {
  const response = await ioRepositoriesFolderRuleDelete({ repositoryId, folderId, ruleId });
  return response.data.rule;
};
// eslint-disable-next-line no-unused-vars
export const updateFieldRuleFolder = async ({ commit }, {
  repositoryId, folderId, ruleId, fields
}) => {
  const response = await ioRepositoriesFolderRuleUpdate({
    repositoryId,
    folderId,
    ruleId
  },
  fields);
  return response.data.rule;
};
// eslint-disable-next-line no-unused-vars
export const saveRulesFolder = async ({ commit }, { repositoryId, folderId, state }) => {
  const response = await ioRepositoriesFolderRulePost({ repositoryId, folderId }, state);
  return response.data.rule;
};

// eslint-disable-next-line no-shadow
export const viewRules = async ({ commit }, { router, folder }) => {
  commit('SET_ELEMENT', folder);
  router.push({
    name: 'list-rules-events',
    params: {
      type: 'folder',
      id: folder.id,
      repositoryId: folder.repositoryId,
      folderId: folder.id,
      ownerId: folder.ownerId
    }
  });
};

// eslint-disable-next-line no-shadow,no-empty-pattern
export const viewRule = async ({}, {
  router, repositoryId, folderId, id
}) => {
  router.push({
    name: 'configure-rules-event',
    params: {
      type: 'folder',
      ruleId: id,
      repositoryId,
      folderId,
    }
  });
};
